import { Module, VuexModule, getModule, MutationAction, Mutation, Action } from 'vuex-module-decorators';
import store from '@/store';
import { Answer as AnswerModel, User as UserModel } from '@/store/models';
import AnswerService from '@/services/AnswerService';
import { ChoiceModule } from './Choice';
import { QuestionModule } from './Question';

@Module({
	dynamic: true,
	name: 'answer',
	store,
})
class Answer extends VuexModule {
	public answer: AnswerModel = {
		questionId: undefined,
		value: ['']
	};
	private answers: AnswerModel[] = [];

	/**
	 * Sets given parameters in answer object.
	 * 
	 * Resets answer if no parameters given.
	 * 
	 * @param questionId
	 * @param value
	 */
	@Mutation
	public setAnswer(): void {
		this.answer = {
			questionId: QuestionModule.activeQuestion.id,
			value: ChoiceModule.choice,
		};
	}

	@Mutation
	public setQuestionId(questionId: number) {
		this.answer.questionId = questionId;
	}

	@Mutation
	public setValue(value: [string | number]) {
		this.answer.value = value;
	}

	/**
	 * Saves answer in API.
	 */
	@Action
	public async saveAnswer(): Promise<boolean> {
		this.setAnswer();

		const success = AnswerService.getInstance().saveAnswer(this.answer);

		// Reset answer if saved successfully
		if (await success === true) {
			ChoiceModule.setChoice(['']);
		}

		return success;
	}
}

export const AnswerModule = getModule(Answer);
